const { find } = require('lodash');

class InspirationNavigationController {
    constructor($state, analyticsService) {
        this.$state = $state;
        this.analyticsService = analyticsService;
    }

    $onInit() {
        if (this.$state.params && this.menuItems) {
            this.openLevel1 = this.$state.params.parent
                ? find(this.menuItems, { UrlPart: this.$state.params.parent })
                : null;
            this.openLevel2 = this.$state.params.child && this.openLevel1 && this.openLevel1.Items
                ? find(this.openLevel1.Items, { UrlPart: this.$state.params.child })
                : null;
        }
    }

    isOpen(category, level = 1) {
        return level === 2
            ? this.$state.includes('shop.inspiration.parent.child', { child: category.UrlPart })
            : this.$state.includes('shop.inspiration.parent', { parent: category.UrlPart });
    }

    toggleCategory(category, level) {
        if (level === 1) {
            this.openLevel1 = this.openLevel1 === category ? null : category;
            this.openLevel2 = null;
        } else {
            this.openLevel2 = this.openLevel2 === category ? null : category;
        }
    }

    pushDataToAnalyticsService() {
        this.analyticsService.push({
            data: {
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.menuClick,
        });
    }
}

const inspirationNavigationComponentDefinition = {
    bindings: {
        menuItems: '<',
    },
    controller: ['$state', 'AnalyticsService', InspirationNavigationController],
    template: require('./inspiration-navigation.component.html').trim(),
};

module.exports = {
    InspirationNavigationController,
    inspirationNavigationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/inspiration/navigation/inspiration-navigation.component.js